import { isSupported, MemoryStorage } from 'local-storage-fallback';

if (!isSupported('localStorage'))
  (window.localStorage as unknown) = new MemoryStorage();

if (!isSupported('sessionStorage'))
  (window.sessionStorage as unknown) = new MemoryStorage();
